var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.8365C18.0768 11.8365 20.2397 10.0644 20.8366 7.67246C20.4087 7.77929 19.961 7.83601 19.5 7.83601C16.4624 7.83601 14 5.37357 14 2.336C14 1.87524 14.0567 1.42771 14.1634 1C11.7717 1.5971 10 3.75987 10 6.33646C10 7.24918 10.2223 8.10997 10.6158 8.86764M5 20.8364C2.79086 20.8364 1 19.0456 1 16.8364C1 14.8586 2.43551 13.216 4.32148 12.8937C5.12876 10.5335 7.3662 8.83643 10 8.83643C12.2882 8.83643 14.2772 10.1173 15.2892 12.0012C15.6744 11.8938 16.0805 11.8364 16.5 11.8364C18.9853 11.8364 21 13.8511 21 16.3364C21 18.8217 18.9853 20.8364 16.5 20.8364C12.6667 20.8364 8.83333 20.8364 5 20.8364Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/memory.2953a2f7039f6b28609e0a00121b3f82.svg";
export { ForwardRef as ReactComponent };